import { Injectable } from '@angular/core';
import { BatchActionService } from './batch-action.service';
import { BroadcastService } from './broadcast.service';
import { LoggerService } from 'src/app/core/logger.service';
import { SyncCryptService } from 'src/app/core/crypt/sync-crypt.service';
import { NotificationsService } from 'src/app/core/notifications.service';
import { ApiService } from 'src/app/core/api.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BatchDeleteService extends BatchActionService{

  constructor(
    public broadcastService: BroadcastService,
    public loggerService: LoggerService,
    public syncCryptService: SyncCryptService,
    public notificationsService: NotificationsService,
    public apiService: ApiService
  ) {
    super(
      broadcastService,
      loggerService,
      syncCryptService,
      notificationsService,
      apiService
    );
  }
  public execute(syncIds: number[]): Subject<any> {
    const subject = new Subject();
    this.loggerService.info(`batchDelete(${syncIds.toString()})`);
    this.ACTION = this.ACT_DELETE;
    this.view.globalCancel = false;
    this.view.completedBatch = [];
    this.view.total = 0;
    this.runBatchItems(syncIds, subject);
    return subject;
  }

  protected async prepareItemForAction(syncId: number): Promise<any> {
    if (this.view.globalCancel) {
      return this.handleCancel();
    } else {
      this.resetProgress();
      this.view.spinner = syncId;

      try {
        const dumpList = await this.dumpDirs(syncId);
        const dumpItems = await this.dropShare(dumpList);
        const syncIds = await this.convertToArray(dumpItems);
        if (this.view.total == 0) {
          this.view.total = syncIds.length;
        }
        if (this.view.globalCancel) {
          return this.handleCancel();
        }
        syncIds.reverse();
        return await this.runProcessTask(syncIds, 0);
      } catch (err) {
        console.log('batch-delete prepareItemForAction err: ', err);
        return this.loggerService.handleError(
          'batch-delete prepareItemForAction',
          err
        );
      }
    }
  }

  protected apiExecuteTask(syncId: number): Promise<any> {
    return this.apiService.execute('batchdelete', { sync_id: syncId });
  }
}
